import { render, staticRenderFns } from "./provider-requests.vue?vue&type=template&id=8c49bd56&"
import script from "./provider-requests.vue?vue&type=script&lang=js&"
export * from "./provider-requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports